// AI Polish — uses the buyer's Groq API key to polish invoice notes / collection emails.
import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiDraftCollectionEmail(
  invoiceNumber: string,
  clientName: string,
  amountDue: string,
  daysOverdue: number,
  onStream: (chunk: string) => void
): Promise<void> {
  const system = `You are a calm, professional accounts receivable specialist. Draft a polite payment reminder email. Be firm but warm. Include: subject line, greeting, invoice reference, amount, days overdue, gentle CTA, sign-off. Output the email only.`;
  try {
    await streamGroq({
      messages: [
        { role: 'system', content: system },
        { role: 'user', content: `Invoice: ${invoiceNumber}\nClient: ${clientName}\nAmount: ${amountDue}\nDays overdue: ${daysOverdue}` },
      ],
      temperature: 0.4,
      onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The invoice tools work fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
